import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface InfoFilledProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const InfoFilled = forwardRef<SVGSVGElement, InfoFilledProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.primary20}
          d='M22 12.004c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10'
        ></path>
        <path
          fill={secondaryColor ?? '#1950A3'}
          fillRule='evenodd'
          d='M10.78 16.89a1.25 1.25 0 1 0 2.5 0v-5.82a1.25 1.25 0 0 0-2.5 0v5.822M12 6.096a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

InfoFilled.displayName = 'InfoFilled';

export default InfoFilled;
